import pluralize from 'pluralize'

const createByIdReducer =
  (entityName) =>
  (state = {}, action) => {
    const pluralEntityName = pluralize(entityName, 2)

    switch (action.type) {
      case `CREATE_${entityName.toUpperCase()}`:
      case `UPDATE_${entityName.toUpperCase()}_SUCCESS`:
      case `FETCH_${entityName.toUpperCase()}_SUCCESS`:
        return {
          ...state,
          [action.entity.id]: {
            ...state[action.entity.id],
            ...action.entity,
          },
        }
      case `UPDATE_${pluralEntityName.toUpperCase()}_SUCCESS`:
      case `FETCH_${pluralEntityName.toUpperCase()}_SUCCESS`:
        return {
          ...state,
          ...action.entities.reduce((newState, entity) => {
            newState[entity.id] = {
              ...state[entity.id],
              ...entity,
            }
            return newState
          }, {}),
        }
      default:
        return state
    }
  }

export default createByIdReducer
